export const FETCHING_DATA = 'feching_data';
export const FETCHING_DATA_SUCCESS = 'response_success';
export const FETCHING_DATA_FAILURE = 'response_failure';
export const SENDING_DATA = 'sending_data';
export const SENDING_DATA_SUCCESS = 'response_success_request';
export const SET_AUTH_TOKEN = 'set_auth_token';
